import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * A manual reload control for pages whose data changes without the user doing anything.
 *
 * Exists because of the native builds: a browser tab can always be reloaded, but a
 * Capacitor app cannot, so without this the only way to see new data is to leave the page
 * and come back. During a round both sides need it -- each player reports from their own
 * phone, so every other page involved goes stale on its own.
 *
 * Renders the button and nothing else, with no wrapper or positioning of its own: it is
 * meant to sit immediately beside whatever the page's main action is, and only the page
 * knows what that is.
 *
 * Icon-only, so it reads as an adjunct to the button next to it rather than competing with
 * it -- a reload is never the thing the user came to do. .btn-icon carries the square
 * aspect ratio and flex: 0 0 auto that keeps it from stretching in a flex row.
 */
@Component({
    standalone: false,
    selector: 'abs-refresh-button',
    template: `
        <ion-button
            class="btn-icon btn-sm"
            fill="clear"
            [disabled]="refreshing"
            [attr.aria-label]="'GLOBAL.EVENTS.REFRESH' | translate"
            [title]="'GLOBAL.EVENTS.REFRESH' | translate"
            (click)="refresh.emit()"
        >
            <ion-icon name="refresh-outline" slot="icon-only"></ion-icon>
        </ion-button>
    `
    // Styles live in army-builder-shared/src/lib/global/styles/events.scss, per the
    // workspace rule against CSS in component files.
})
export class RefreshButtonComponent {
    /** Disables the button while a fetch is in flight, so it cannot be queued up twice. */
    @Input() refreshing = false;

    @Output() refresh = new EventEmitter<void>();
}
